/**
 *
 * Asynchronously loads the component for InstallationInstructions
 *
 */

import { lazyLoad } from 'utils/loadable';

export const CoffeeTalkSuccess = lazyLoad(
  () => import('./index'),
  module => module.CoffeeTalkSuccess,
);
